<template>
  <Breadcrumb />
</template>
<script>
export default {
  name: "SystemLoginInformations",
  mounted() {
    this.$router.push({ name: "PageUnderConstruction" });
  },
};
</script>
